const PREFIX = "TECH_SHEET";
const TECH_SHEET_TYPES = {
  CREATE_TECH_SHEET: `${PREFIX}/CREATE`,
  UPDATE_TECH_SHEET: `${PREFIX}/UPDATE`,
  GET_TECH_SHEET: `${PREFIX}/GET`,
  SET_HTML_STRUCTURE: `${PREFIX}/SET_HTML_STRUCTURE`,
  CLEAR: `${PREFIX}/CLEAR`,
};

export default TECH_SHEET_TYPES;
